<template>
    <section id="mainContainer">
        <adminHeader></adminHeader>
        <section class="admin-mid-container">
            <div class="admin-custom-row admin-page-row" id="leftMenuSlideBox">
                <adminNavigation></adminNavigation>
                <section class="admin-right-sidebar">
                    <div class="admin-right-sidebar-in">
                        <div class="admin-right-sidebar-in-top">
                            <div class="admin-custom-row">
                                <div class="admin-right-sidebar-in-top-left">
                                    <h1>
                                        {{ constants.MANAGE_INDUSTRY_TEXT }}
                                    </h1>
                                    <div class="admin-page-type-links">
                                        <ul>
                                            <li>
                                                <a id="allLink" href="#" :class="{ active: activeTab === 'all' }"
                                                    @click="switchView('all')">
                                                    {{ constants.ALL_LINK }}
                                                    <span>{{ counts.all }}</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a id="publishedhLink" href="#"
                                                    :class="{ active: activeTab === 'published' }"
                                                    @click="switchView('published')">
                                                    {{ constants.PUBLISHED_LINK }}
                                                    <span>{{ counts.published }}</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a id="unPublishedhLink" href="#"
                                                    :class="{ active: activeTab === 'unpublished' }"
                                                    @click="switchView('unpublished')">
                                                    {{ constants.UNPUBLISHED_LINK }}
                                                    <span>{{ counts.unpublished }}</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="admin-right-sidebar-in-top-right">

                                    <div class="admin-right-sidebar-in-top-right-top">
                                        <div class="admin-search-box">
                                            <input id="adminSearchInput" type="text" placeholder="Search"
                                                v-model="searchedText"
                                                @keyup.enter="fetchIndustries(activeTab), fetchCounts(searchedText)" />
                                        </div>
                                        <div class="admin-add-btn">
                                            <button id="addIndustryButton" class="add-btn-admin" :class="{ 'active': showAddForm }"
                                                @click="showAddForm = true, selectedIndustries = [], selectAll = false, cancelEdit()">
                                                <i class="add-icon"></i>
                                                {{ constants.ADD_INDUSTRY_BUTTON }}
                                            </button>
                                        </div>
                                    </div>
                                    <div class="admin-right-sidebar-in-top-right-btm"
                                        v-if="selectedIndustries.length > 1">
                                        <div class="tags">
                                            <ul>
                                                <li>
                                                    <span>{{ selectedIndustries.length }} entries selected</span>
                                                    <button id="tagCloseBtn"
                                                        @click="selectedIndustries = [], selectAll = false"></button>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="delete-all-btn-link">
                                            <button class="btn_link" id="deleteAllBtn" data-bs-toggle="modal"
                                                data-bs-target="#deletePop" @click="setDeleteMode('all')">
                                                {{ constants.DELETE_ALL_BUTTON }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="showAddForm" class="white-bg-border add-new-section">
                            <div class="add-banner-image-section">
                                <h2>
                                    {{ constants.ADD_NEW_INDUSTRY_TEXT }}
                                </h2>
                                <div class="add-banner-image-box">
                                    <form id="addIndustryForm" @submit.prevent="submitForm">
                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.TITLE_LABEL }}
                                            </label>
                                            <input id="industryTitleInput" type="text" placeholder="Enter the Title"
                                                v-model="newIndustrie.title" />
                                            <div class="error-msg" v-if="!newIndustrie.title">{{ errMsg }}</div>
                                        </div>

                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.SUB_HEADING_LABEL }}
                                            </label>
                                            <ckeditor placeholder="Short Description" class="text-editer"
                                                id="industrySubHeadingInput" :editor="editor"
                                                v-model="newIndustrie.shortDescription" :config="editorConfig">
                                            </ckeditor>
                                            <div class="error-msg" v-if="!newIndustrie.shortDescription">{{ errMsg }}
                                            </div>

                                        </div>

                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.DESCRIPTION_LABEL }}
                                            </label>
                                            <ckeditor placeholder="Description" class="text-editer"
                                                id="industryDescriptionInput" :editor="editor"
                                                v-model="newIndustrie.description" :config="editorConfig"></ckeditor>
                                            <div class="error-msg" v-if="!newIndustrie.description">{{ errMsg }}</div>

                                        </div>

                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.INDUSTRY_IMAGE_LABEL }}
                                            </label>
                                            <div class="image-upload-input upload-banner-image">
                                                <div
                                                    :class="['image-upload-input-item', { 'uploaded-done': imageUploaded }]">
                                                    <div class="file-input-box">
                                                        <button class="image-upload-input-item-delete-btn" id="uploaded-img-delete-btn" type="button"
                                                            @click="clearUploadedImage(false)"></button>
                                                        <input id="addIndustryImageInput"
                                                            @change="handleFileUpload($event, false)" accept="image/jpeg,image/jpg,image/png"
                                                            type="file">
                                                    </div>
                                                    <div class="image-upload-input-item-in" v-if="!imageUploaded">
                                                        <div class="image-upload-input-item-icon">
                                                            <img src="@/assets/images/admin-img/image-icon.svg"
                                                                alt="" />
                                                        </div>
                                                        <span>
                                                            {{ constants.ADD_IMAGE_LABEL }}
                                                        </span>
                                                    </div>
                                                    <div class="image-upload-input-item-uploaded" v-if="imageUploaded">
                                                        <img :src="imageUrl" alt="" class="mCS_img_loaded">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="error-msg" v-if="!selectedFile">{{ errMsg }}</div>
                                        </div>

                                        <div class="admin-input-field-submit">
                                            <button id="industrySubmitBtn" type="submit"
                                                class="admin-btn-outline-primary add-new-cancel" :disabled="isSubmitting">
                                                {{ constants.SUBMIT_BUTTON }}
                                            </button>
                                            <button id="industryCancleBtn" type="button"
                                                class="admin-btn-outline-secondary add-new-cancel" @click="resetForm">
                                                {{ constants.CANCEL_BUTTON }}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div :class="['admin-item-list-section banner-image-section', { 'show-edit-item-outer': editFormSubmitted }]"
                            v-if="editIndustriesData.length > 0">
                            <div class="admin-item-list-section-in" ref="scrollWrapper" data-simplebar>
                                <div class="admin-item-list-section-scroll">
                                    <div class="admin-item-list-top">
                                        <div class="admin-item-list-row">
                                            <div class="admin-item-checkbox">
                                                <div class="admin-checkbox-input">
                                                    <input name="cssCheckbox" id="selectAll" type="checkbox"
                                                        class="css-checkbox" @change="toggleSelectAll"
                                                        :checked="selectAll === true">
                                                    <label for="selectAll"></label>
                                                </div>
                                            </div>
                                            <div class="admin-item-image">
                                                {{ constants.IMAGE_LABEL }}
                                            </div>
                                            <div class="admin-item-sm-title" @click="toggleSort('title')" style="cursor: pointer;">
                                                {{ constants.TITLE_LABEL }}
                                                <button v-if="sortBy === 'title' || sortBy === '-title'" class="sorting-btn" :class="{ 'sorted': sortBy === '-title' }">
                                                </button>
                                            </div>
                                            <div class="admin-item-industry-sort-desc" @click="toggleSort('shortDescription')" style="cursor: pointer;">
                                                {{ constants.SUB_HEADING_LABEL }}
                                                <button v-if="sortBy === 'shortDescription' || sortBy === '-shortDescription'" class="sorting-btn" :class="{ 'sorted': sortBy === '-shortDescription' }">
                                                </button>
                                            </div>
                                            <div class="admin-item-industry-desc" @click="toggleSort('description')" style="cursor: pointer;">
                                                {{ constants.DESCRIPTION_LABEL }}
                                                <button v-if="sortBy === 'description' || sortBy === '-description'" class="sorting-btn" :class="{ 'sorted': sortBy === '-description' }">
                                                </button>
                                            </div>
                                            <div class="admin-item-actions">
                                                {{ constants.ACTIONS_LABEL }}
                                            </div>
                                            <div class="clear"></div>
                                        </div>
                                    </div>
                                    <div class="admin-item-list-btm">
                                        <div ref="sortableList">
                                        <div v-for="(industrie, index) in editIndustriesData" :key="industrie.id"
                                            :class="['admin-item-box', { 'show-edit-item': industrie.editing }]">
                                            <div class="admin-item-box-top">
                                                <div class="admin-item-list-row">
                                                    <div class="admin-item-checkbox">
                                                        <div class="admin-checkbox-input">
                                                            <input name="cssCheckbox" :id="'demo_opt_' + industrie.id"
                                                                type="checkbox" class="css-checkbox"
                                                                @change="toggleIndustrieSelection(industrie.id)"
                                                                :checked="selectedIndustries.includes(industrie.id)">
                                                            <label :for="'demo_opt_' + industrie.id"></label>
                                                        </div>
                                                    </div>
                                                    <div class="admin-item-image">
                                                        <div class="sm-img">
                                                            <img :src="getCdnImageAddress(industrie.industryImage, `w_40,h_41/`) || '@/assets/images/admin-img/demo-img/item-img-1.jpg'"
                                                                alt="" />
                                                        </div>
                                                    </div>
                                                    <div class="admin-item-sm-title text-limit">
                                                        {{ industrie.title }}
                                                    </div>
                                                    <div class="admin-item-industry-sort-desc text-limit">
                                                        {{ useStripHtml(industrie.shortDescription) }}
                                                    </div>
                                                    <div class="admin-item-industry-desc text-limit">
                                                        {{ useStripHtml(industrie.description) }}
                                                    </div>

                                                    <div class="admin-item-actions">
                                                        <ul class="admin-action-link">
                                                            <li>
                                                                <button id="industryPgEditBtn" class="editBtn"
                                                                    @click="editIndustrie(index), showAddForm = false">
                                                                    {{ constants.EDIT_BUTTON }}
                                                                </button>
                                                            </li>
                                                            <li>
                                                                <button id="industryPgDeleteBtn" data-bs-toggle="modal"
                                                                    data-bs-target="#deletePop"
                                                                    @click="setDeleteMode('single', industrie.id), showAddForm = false, cancelEdit()">
                                                                    {{ constants.DELETE_BUTTON }}
                                                                </button>
                                                            </li>
                                                            <li><button id="industryPgUnPublishBtn"
                                                                    class="primary-outline-btn"
                                                                    v-if="industrie.status === 1"
                                                                    @click="changeIndustrieStatus(industrie.id, 0)">
                                                                    {{ constants.UNPUBLISH_BUTTON }}
                                                                </button>
                                                                <button id="industryPgPublishBtn"
                                                                    class="primary-outline-btn"
                                                                    v-else-if="industrie.status === 0"
                                                                    @click="changeIndustrieStatus(industrie.id, 1)">
                                                                    {{ constants.PUBLISH_BUTTON }}
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="clear"></div>
                                                </div>
                                            </div>
                                            <div class="admin-item-box-btm" v-if="industrie.editing">
                                                <div class="add-banner-image-section">
                                                    <h2>
                                                        {{ constants.EDIT_INDUSTRY_TEXT }}
                                                    </h2>
                                                    <div class="add-banner-image-box">
                                                        <div class="admin-input-field">
                                                            <label>
                                                                {{ constants.TITLE_LABEL }}
                                                            </label>
                                                            <input id="industryTitleInput" type="text"
                                                                placeholder="Enter the Title"
                                                                v-model="editIndustrieData.title" />
                                                            <div class="error-msg" v-if="!editIndustrieData.title">
                                                                {{ errEditMsg }}</div>
                                                        </div>

                                                        <div class="admin-input-field">
                                                            <label>
                                                                {{ constants.SUB_HEADING_LABEL }}
                                                            </label>
                                                            <ckeditor placeholder="Short Description"
                                                                id="industrySubHeadingInput" class="text-editer"
                                                                :editor="editor"
                                                                v-model="editIndustrieData.shortDescription"
                                                                :config="editorConfig"></ckeditor>
                                                            <div class="error-msg"
                                                                v-if="!editIndustrieData.shortDescription">{{ errEditMsg
                                                                }}
                                                            </div>
                                                        </div>

                                                        <div class="admin-input-field">
                                                            <label>
                                                                {{ constants.DESCRIPTION_LABEL }}
                                                            </label>

                                                            <ckeditor placeholder="Description"
                                                                id="industryDescriptionInput" class="text-editer"
                                                                :editor="editor" v-model="editIndustrieData.description"
                                                                :config="editorConfig"></ckeditor>
                                                            <div class="error-msg"
                                                                v-if="!editIndustrieData.description">
                                                                {{ errEditMsg }}</div>

                                                        </div>

                                                        <div class="admin-input-field">
                                                            <label>
                                                                {{ constants.INDUSTRY_IMAGE_LABEL }}
                                                            </label>
                                                            <div class="image-upload-input upload-banner-image">
                                                                <div class="image-upload-input-item uploaded-done">
                                                                    <div class="file-input-box">
                                                                        <button class="image-upload-input-item-delete-btn" id="uploaded-img-delete-btn" type="button"
                                                                            @click="clearUploadedImage(true)"></button>
                                                                        <input id="editIndustryImageInput" type="file"
                                                                            @change="handleFileUpload($event, true)"
                                                                            accept="image/jpeg,image/jpg,image/png" />
                                                                    </div>

                                                                    <div class="image-upload-input-item-uploaded">
                                                                        <img :src="editimageSrc || require('@/assets/images/admin-img/image-icon.svg')" alt="" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="error-msg" v-if="!editimageSrc && !selectedEditFile">{{ errEditMsg }}</div>
                                                        </div>

                                                        <div class="admin-input-field-submit">
                                                            <button id="industrySubmitBtn"
                                                                class="admin-btn-outline-primary"
                                                                @click="submitEditForm(industrie.id)">
                                                                {{ constants.SUBMIT_BUTTON }}
                                                            </button>
                                                            <button id="industryCancleBtn"
                                                                class="admin-btn-outline-secondary addNewCancel"
                                                                @click="cancelEdit">
                                                                {{ constants.CANCEL_BUTTON }}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="admin-pagination-section">
                                <div class="custom-row">
                                    <div class="item-show-selectbox">
                                        <select id="paginationSelectBox" v-model="limit" @change="handleLimitChange">
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                        <span> {{ constants.ENTRIES_PER_PAGE_LABEL }}</span>
                                    </div>
                                    <div class="admin-pagination" id="paginationBox" v-if="totalPages > 1">
                                        <ul>
                                            <li v-if="currentPage !== 1" @click="changePage(currentPage - 1)">
                                                <a href="#" class="pagination-previous"></a>
                                            </li>
                                            <li v-for="page in visiblePages" :key="page" @click="changePage(page)"
                                                v-if="totalPages != 1">
                                                <a href="#" :class="{ active: currentPage === page }">{{ page }}</a>
                                            </li>
                                            <li v-if="currentPage !== totalPages" @click="changePage(currentPage + 1)">
                                                <a href="#" class="pagination-next"></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <p>No data to display</p>
                        </div>
                    </div>
                </section>
            </div>
        </section>
        <footer class="admin-site-footer">
            <div class="container">
                {{ constants.COPYRIGHT_TEXT }}
            </div>
        </footer>


        <div class="modal fade confirmation-popup" id="deletePop" tabindex="-1" role="dialog"
            aria-labelledby="deleteModalLabel" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="confirmation-popup-icon">
                        <i>
                            <img src="@/assets/images/admin-img/light_delete-outline.svg" alt="" />
                        </i>
                    </div>
                    <div class="confirmation-popup-mid">
                        <p>{{ constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT }}</p>
                    </div>
                    <div class="confirmation-popup-btm">
                        <button id="popNoBtn" class="admin-btn-outline-secondary" data-bs-dismiss="modal">
                            {{ constants.NO_BUTTON }}
                        </button>
                        <button id="popYesBtn" class="admin-btn-outline-primary" data-bs-dismiss="modal"
                            @click="confirmDelete">
                            {{ constants.YES_BUTTON }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>
<script lang="ts">
import { defineComponent, ref, nextTick } from 'vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import constants from "@/utils/en-US-Admin.json";
import adminHeader from "@/components/adminHeader.vue";
import adminNavigation from "@/components/adminNavigation.vue";
import axios from 'axios';
import { RouteLocationNormalized, NavigationGuardNext } from "vue-router";
import Swal from 'sweetalert2';
import { environment } from '@/config/environment';
import { API_BASE_URL } from '@/config/api.config';
import Sortable, { SortableEvent } from 'sortablejs';
import {
  getPaginationLimit,
  setPaginationLimit,
} from "@/utils/paginationUtils";

interface Counts {
    all: number;
    published: number;
    unpublished: number;
}

interface Industrie {
    id: number;
    title: string;
    shortDescription: string;
    description: string;
    industryImage: string;
    status: number;
    editing?: boolean;
    Created_at?: string
    position: number; // Add position field
}

export default defineComponent({
    name: "Industrie",
    data() {
        return {
            constants,
            errMsg: '',
            errEditMsg: '',
            editor: ClassicEditor,
            searchTempVar: '',
            activeTab: 'all',
            imageSrc: '',
            editimageSrc: '',
            showAddForm: false,
            limit: 10,
            selectedFile: null as File | null,
            selectedEditFile: null as File | null,
            imageUploaded: false,
            selectAll: false,
            editFormSubmitted: false,
            industries: [] as Industrie[],
            editIndustriesData: [] as Industrie[],
            selectedIndustries: [] as number[],
            totalPages: 0,
            currentPage: 1,
            searchedText: '',
            counts: {
                all: 0,
                published: 0,
                unpublished: 0,
            } as any,
            editorConfig: {
                toolbar: {
                    items: [
                        'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'outdent', 'indent', '|', 'undo', 'redo', '|', 'insertTable',
                    ]
                },
            },
            newIndustrie: {
                title: '',
                shortDescription: '',
                description: '',
                industryImage: ''
            },
            editIndustrieData: {
                title: '',
                shortDescription: '',
                description: '',
                industryImage: ''
            },
            industrieToDelete: null as number | null,
            deleteMode: 'all' as 'all' | 'single',
            isSubmitting: false,
            isDragging: false, // Add for drag state
            sortableInstance: null as Sortable | null,
            sortBy: '-position' as string,
        };
    },
    beforeRouteEnter(
        to: RouteLocationNormalized,
        from: RouteLocationNormalized,
        next: NavigationGuardNext
    ) {
        const isLoggedIn = localStorage.getItem('isLoggedIn');
        if (isLoggedIn !== "true") {
            next({ name: 'Login' });
        } else {
            next();
        }
    },
    computed: {
        imageUrl(): string {
            return this.imageSrc || require('@/assets/images/admin-img/image-icon.svg');
        },
        editImage(): string {
            return this.editimageSrc || require('@/assets/images/admin-img/image-icon.svg');
        },
        visiblePages() {
            const maxVisiblePages = 5;
            const halfMaxVisiblePages = Math.floor(maxVisiblePages / 2);
            let start = Math.max(this.currentPage - halfMaxVisiblePages, 1);
            let end = start + maxVisiblePages - 1;

            if (end > this.totalPages) {
                end = this.totalPages;
                start = Math.max(end - maxVisiblePages + 1, 1);
            }

            return Array.from({ length: end - start + 1 }, (_, i) => start + i);
        },
    },
    components: {
        adminHeader,
        adminNavigation
    },
    created() {
        this.limit = getPaginationLimit("industries", 10);
        this.fetchCounts();
        this.fetchIndustries();
    },

    mounted() {
    this.setupSortable(); // Initialize SortableJS on mount
    },
    methods: {

        setDeleteMode(mode: any, industrieId?: number) {
            this.deleteMode = mode;
            if (industrieId !== undefined) {
                this.industrieToDelete = industrieId;
            }
        },
        confirmDelete() {
            if (this.deleteMode === 'all') {
                this.deleteSelectedContacts();
            } else if (this.deleteMode === 'single') {
                this.deleteIndustrie();
            }
        },
        changePage(page: number) {
            if (page > 0 && page <= this.totalPages) {
                this.currentPage = page;
                this.fetchIndustries(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
                this.selectAll = false
                this.selectedIndustries = []
            }
        },

        handleFileUpload(event: any, isEdit: boolean = false) {
            const target = event.target as HTMLInputElement;
            if (target && target.files && target.files.length > 0) {
                const file = target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = (e) => {
                    if (e.target && typeof e.target.result === 'string') {
                        if (isEdit) {
                            this.editimageSrc = e.target.result;
                            this.selectedEditFile = file;
                        } else {
                            this.imageSrc = e.target.result;
                            this.selectedFile = file;
                            this.imageUploaded = true
                        }
                    }
                };
            }
        },
        toggleIndustrieSelection(industrieId: number) {
            if (this.selectedIndustries.includes(industrieId)) {
                this.selectedIndustries = this.selectedIndustries.filter(id => id !== industrieId);
            } else {
                this.selectedIndustries.push(industrieId);
            }


        },
        toggleSelectAll() {
            if (this.selectAll === true) {
                this.selectedIndustries = [];
                this.selectAll = false
            } else {
                this.selectedIndustries = this.editIndustriesData.map(industrie => industrie.id);
                this.selectAll = true
            }
        },

        async submitForm() {
    if (!this.newIndustrie.title || !this.newIndustrie.shortDescription || !this.newIndustrie.description || !this.selectedFile) {
        this.errMsg = "This Field Is Required";
        return;
    }
    this.isSubmitting = true;
    const formData = new FormData();
    formData.append('title', this.newIndustrie.title);
    formData.append('shortDescription', this.newIndustrie.shortDescription);
    formData.append('description', this.newIndustrie.description);
    formData.append('industryImage', this.selectedFile);

    try {
        const response = await fetch(`${API_BASE_URL}/industry/`, {
            method: 'POST',
            body: formData
        });
        await response.json();
        this.resetForm();
        await this.fetchCounts(); // Fetch counts first
        // Adjust currentPage if needed
        if (this.counts[this.activeTab] > this.limit * this.currentPage) {
            this.currentPage = Math.ceil(this.counts[this.activeTab] / this.limit);
        }
        await this.fetchIndustries(this.activeTab, this.limit, (this.currentPage - 1) * this.limit); // Fetch industries with current limit
        this.imageUploaded = false;
        Swal.fire({
            icon: 'success',
            title: 'Industry Created Successfully!',
            showConfirmButton: false,
            timer: 1500
        });
    } catch (error) {
        console.error('Error submitting industry:', error);
    } finally {
        this.isSubmitting = false;
    }
},
        async deleteSelectedContacts() {
    try {
        await axios.delete(`${API_BASE_URL}/industry/bulk_delete/`, { data: { ids: this.selectedIndustries } });
        this.editIndustriesData = this.editIndustriesData.filter(industrie => !this.selectedIndustries.includes(industrie.id));
        this.selectedIndustries = [];
        await this.fetchCounts(); // Update counts
        await this.fetchIndustries(this.activeTab, this.limit, (this.currentPage - 1) * this.limit); // Refresh industries
        if (this.editIndustriesData.length === 0 && this.currentPage > 1) {
            this.currentPage--;
            await this.fetchIndustries(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        }
        this.selectAll = false;
    } catch (error) {
        console.error('Error deleting contacts:', error);
    }
},
        async submitEditForm(industrieId: number) {
            if (!this.editIndustrieData.title || !this.editIndustrieData.shortDescription || !this.editIndustrieData.description || (!this.selectedEditFile && !this.editimageSrc)) {
                this.errEditMsg = 'This Field Is Required'
                return
            }
            const formData = new FormData();
            formData.append('title', this.editIndustrieData.title);
            formData.append('shortDescription', this.editIndustrieData.shortDescription);
            formData.append('description', this.editIndustrieData.description);
            if (this.selectedEditFile) {
                formData.append('industryImage', this.selectedEditFile);
            }

            try {
                const response = await axios.patch(`${API_BASE_URL}/industry/${industrieId}/`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
                this.fetchIndustries();
                this.cancelEdit();
                this.editFormSubmitted = false;
                Swal.fire({
                    icon: 'success',
                    title: 'Industry Updated Successfully!',
                    showConfirmButton: false,
                    timer: 1500
                });
            } catch (error) {
                console.error('Error updating industrie:', error);
            }
        },

        handleLimitChange() {
    setPaginationLimit("industries", this.limit);
    this.currentPage = 1;
    this.totalPages = Math.ceil(this.counts[this.activeTab] / this.limit);
    this.selectAll = false;
    this.selectedIndustries = [];
    this.fetchIndustries(this.activeTab, this.limit, 0, );
},

//@ts-expect-error
        async fetchIndustries(status = 'all', limit?: number, skip = 0, sortBy = this.sortBy) {
    const effectiveLimit = limit ?? this.limit;

    let url = `${API_BASE_URL}/industry/`;
    const params = new URLSearchParams();
    if (status === 'published') params.append('status', '1');
    else if (status === 'unpublished') params.append('status', '0');

    // Only reset currentPage for a new search, preserve limit
    if (this.searchedText && !this.searchTempVar) {
        this.currentPage = 1;
        this.searchTempVar = this.searchedText;
    }
    if (!this.searchedText && this.searchTempVar) {
        this.currentPage = 1;
        this.searchTempVar = '';
    }

    params.append('limit', effectiveLimit.toString());
    params.append('skip', skip.toString());
    if (this.searchedText) {
        params.append('searchedText', this.searchedText);
    }
     params.append('sort_by', sortBy);

    try {
        const response = await axios.get(`${url}?${params.toString()}`);
        this.editIndustriesData = response.data;
        this.totalPages = Math.ceil(this.counts[status] / effectiveLimit); // Update totalPages
        console.log('Industries Fetched:', this.editIndustriesData.length, 'Total Pages:', this.totalPages); // Debug log
        this.setupSortable();
    } catch (error) {
        console.error('Error fetching industries:', error);
    }
},
async switchView(status: string) {
    this.currentPage = 1;
    this.activeTab = status;
    this.selectedIndustries = [];
    this.selectAll = false;
    this.editFormSubmitted = false;
    await this.fetchIndustries(status, this.limit, 0); // Use current limit
    if (status === 'published') {
        this.totalPages = Math.ceil(this.counts.published / this.limit);
    } else if (status === 'unpublished') {
        this.totalPages = Math.ceil(this.counts.unpublished / this.limit);
    } else {
        this.totalPages = Math.ceil(this.counts.all / this.limit);
    }
},
        async fetchCounts(searchedText?: string) {
    try {
        const baseUrl = `${API_BASE_URL}/industry/count/`;
        const queryParam = searchedText ? `?searchedText=${searchedText}&status=` : '?status=';

        const [allResponse, publishedResponse, unpublishedResponse] = await Promise.all([
            axios.get(`${baseUrl}${queryParam}0&status=1`),
            axios.get(`${baseUrl}${queryParam}1`),
            axios.get(`${baseUrl}${queryParam}0`)
        ]);

        this.counts = {
            all: allResponse.data.count,
            published: publishedResponse.data.count,
            unpublished: unpublishedResponse.data.count
        };

        if (this.activeTab in this.counts) {
            this.totalPages = Math.ceil(this.counts[this.activeTab] / this.limit); // Use this.limit instead of 10
            console.log('Counts:', this.counts, 'Total Pages:', this.totalPages, 'Limit:', this.limit); // Debug log
        } else {
            console.error(`Invalid active tab: ${this.activeTab}`);
        }
    } catch (error) {
        console.error('Error fetching industry counts:', error);
    }
},


        editIndustrie(index: number) {
            this.editIndustriesData.forEach((industrie, i) => {
                industrie.editing = i === index;
            });
            this.editFormSubmitted = true;
            const selectedIndustrie = this.editIndustriesData[index];
            this.editIndustrieData = {
                title: selectedIndustrie.title,
                shortDescription: selectedIndustrie.shortDescription,
                description: selectedIndustrie.description,
                industryImage: selectedIndustrie.industryImage || ''
            };
            this.editimageSrc = selectedIndustrie.industryImage
                ? this.getCdnImageAddress(selectedIndustrie.industryImage, 'w_200,h_100/')
                : '';

            if (this.sortableInstance) {
              this.sortableInstance.option('disabled', true);
          }
        },

        resetForm() {
            this.newIndustrie = {
                title: '',
                shortDescription: '',
                description: '',
                industryImage: ''
            };
            this.selectedFile = null;
            this.imageSrc = '';
            this.showAddForm = false;
            this.imageUploaded = false;
            this.errMsg = '';
        },

        cancelEdit() {
            this.editIndustriesData.forEach((industrie) => {
                industrie.editing = false;
            });
            this.editIndustrieData = {
                title: '',
                shortDescription: '',
                description: '',
                industryImage: ''
            };
            this.editFormSubmitted = false;
            this.selectedEditFile = null;
            this.editimageSrc = '';
            this.errEditMsg = '';
            if (this.sortableInstance) {
          this.sortableInstance.option('disabled', false);
     }
        },

        async deleteIndustrie() {
    try {
        await axios.delete(`${API_BASE_URL}/industry/${this.industrieToDelete}/`);
        await this.fetchCounts(); // Update counts
        await this.fetchIndustries(this.activeTab, this.limit, (this.currentPage - 1) * this.limit); // Refresh industries
        if (this.editIndustriesData.length === 0 && this.currentPage > 1) {
            this.currentPage--;
            await this.fetchIndustries(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        }
        (this.$refs.dummyButton as HTMLElement)?.click();
    } catch (error) {
        console.error('Error deleting industry:', error);
    }
},

        async changeIndustrieStatus(industrieId: number, newStatus: number) {
    try {
        const formData = new FormData();
        formData.append('status', newStatus.toString());

        await axios.patch(`${API_BASE_URL}/industry/${industrieId}/`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        await this.fetchCounts(); // Update counts
        await this.fetchIndustries(this.activeTab, this.limit, (this.currentPage - 1) * this.limit); // Refresh industries
        if (this.editIndustriesData.length === 0 && this.currentPage > 1) {
            this.currentPage--;
            await this.fetchIndustries(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        }
    } catch (error) {
        console.error('Error updating industry status:', error);
    }
},
        getCdnImageAddress(src: string, size: string): string {
            if (!src) return '';
            let cdnUrl: string = environment.imageCdn.getHost;
            cdnUrl = cdnUrl.concat(size);
            return cdnUrl + encodeURIComponent(src);
        },
        useStripHtml(html : string) {
            let regex = /(<([^>]+)>)/ig;
            return html.replace(regex, "");
        },setupSortable() {
      nextTick(() => {
        const sortableList = this.$refs.sortableList as HTMLElement;
        if (!sortableList) {
          console.error('Sortable list ref not found!');
          return;
        }

        if (this.sortableInstance) {
          this.sortableInstance.destroy();
        }

        this.sortableInstance = Sortable.create(sortableList, {
          animation: 150,
          draggable: '.admin-item-box',
          ghostClass: 'sortable-ghost',
          chosenClass: 'sortable-chosen',
          dragClass: 'sortable-drag',
          filter: '.css-checkbox, button, input, select, textarea, a, .ck-editor, .ck-content, .admin-item-box-btm', // Include edit form
          preventOnFilter: true,
          disabled: this.editFormSubmitted, // Disable dragging when editing
          onStart: (evt: SortableEvent) => {
            this.isDragging = true;
            if (['title', '-title', 'description', '-description', 'shortDescription', '-shortDescription'].includes(this.sortBy)) {
              evt.preventDefault();
              Swal.fire({
                icon: "warning",
                title: "Cannot Drag",
                text: "First remove sorting then you can be able to drag   it.",
                timer: 2000,
                showConfirmButton: false,
              });
              return false;
            }
          },
          onEnd: async (evt: SortableEvent) => {
            this.isDragging = false;
            const oldIndex = evt.oldIndex!;
            const newIndex = evt.newIndex!;

            if (oldIndex === newIndex) return;

            // Optimistically update local data
            const newArticlesData = [...this.editIndustriesData];
            const [movedItem] = newArticlesData.splice(oldIndex, 1);
            newArticlesData.splice(newIndex, 0, movedItem);

            

            const totalItems = newArticlesData.length;
            newArticlesData.forEach((item, index) => {
            item.position = totalItems - index; // Highest position for top item
            });



            // Update reactive property
            this.editIndustriesData = newArticlesData;

            // Prepare data for backend sync
            const reorderedItems = newArticlesData.map((item) => ({
              id: item.id,
              position: item.position,
            }));

            try {
              console.log(reorderedItems,'hhhhhhhhhh')
              await axios.post(`${API_BASE_URL}/industry/reorder/`, {
                items: reorderedItems,
              });

              // Fetch updated data from server
              await this.fetchIndustries(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);

              Swal.fire({
                icon: 'success',
                title: 'Order Updated Successfully!',
                timer: 1500,
                showConfirmButton: false,
              });
            } catch (error) {
              console.error('Error updating order:', error);
              await this.fetchIndustries(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
              Swal.fire({
                icon: 'error',
                title: 'Order Update Failed!',
                text: 'Reverted to last saved order.',
                showConfirmButton: false,
                timer: 1500,
              });
            }
          },
        });

        console.log('Sortable instance created:', this.sortableInstance);
    });
},

clearUploadedImage(isEdit: boolean) {
	if (isEdit) {
      this.editimageSrc = '';
      this.selectedEditFile = null;
      const fileInput = document.getElementById('editIndustryImageInput') as HTMLInputElement;
      if (fileInput) {
          fileInput.value = '';
      }
	} else {
        this.imageSrc = '';
        this.selectedFile = null;
        this.imageUploaded = false;
        const fileInput = document.getElementById('addIndustryImageInput') as HTMLInputElement;
        if (fileInput) {
            fileInput.value = '';
        }
    }
},

toggleSort(field: string) {
            if (this.sortBy === field) {
                this.sortBy = `-${field}`; 
            } else if (this.sortBy === `-${field}`) {
                this.sortBy = '-position'; 
            } else {
                this.sortBy = field; 
            }
            this.fetchIndustries(this.activeTab, this.limit, (this.currentPage - 1) * this.limit, this.sortBy);
        },

 
  },
});
</script>

<style scoped>
.admin-item-box-top {
  cursor: move;
}
.admin-item-box.dragging {
  opacity: 0.5;
}
</style>